import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Dokument } from './dokument';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dokument',
  templateUrl: './dokument.component.html'
})
export class DokumentComponent 
extends BaseModalContainer<Dokument>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Dokument>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService);

   }

  ngOnInit() {
  }

}
